import { DispatchType, StoreAction, StoreState } from "../reduxTypes";
import { parseError } from '../../utils/http-helper';
import preCadastroService from "../../services/preCadastro";
import { PreCadastroType } from "../../types/PreCadastro.types";
import { message } from "antd";

export const PRE_CADASTRO__INICIALIZA_ESTADO = 'PRE_CADASTRO__INICIALIZA_ESTADO';
export const PRE_CADASTRO__SET_DADOS_INICIAIS = 'PRE_CADASTRO__SET_DADOS_INICIAIS';
export const PRE_CADASTRO__SET_LISTA_CIDADES = 'PRE_CADASTRO__SET_LISTA_CIDADES';
export const PRE_CADASTRO__SET_DATAS_ATENDIMENTO = 'PRE_CADASTRO__SET_DATAS_ATENDIMENTO';
export const PRE_CADASTRO__SET_HORARIOS_ATENDIMENTO = 'PRE_CADASTRO__SET_HORARIOS_ATENDIMENTO';
export const PRE_CADASTRO__SET_AGENDAMENTO_ATUAL = 'PRE_CADASTRO__SET_AGENDAMENTO_ATUAL';
export const PRE_CADASTRO__SET_DADOS = 'PRE_CADASTRO__SET_DADOS';
export const PRE_CADASTRO__LIMPAR_DADOS = 'PRE_CADASTRO__LIMPAR_DADOS';
export const PRE_CADASTRO__CONCLUIR_CADASTRO = 'PRE_CADASTRO__CONCLUIR_CADASTRO';
export const PRE_CADASTRO__JA_CADASTRADO = 'PRE_CADASTRO__JA_CADASTRADO';

function setDados(dados: PreCadastroType): StoreAction {
  return {
    type: PRE_CADASTRO__SET_DADOS,
    payload: dados,
  };
}

function setEstadoInicial(): StoreAction {
  return { type: PRE_CADASTRO__INICIALIZA_ESTADO };
}

function setDadosIniciais(dados: Object): StoreAction {
  return {
    type: PRE_CADASTRO__SET_DADOS_INICIAIS,
    payload: dados,
  };
}

function setListaCidades(dados: Object): StoreAction {
  return {
    type: PRE_CADASTRO__SET_LISTA_CIDADES,
    payload: dados,
  };
}

function setDatasAtendimento(dados: Object): StoreAction {
  return {
    type: PRE_CADASTRO__SET_DATAS_ATENDIMENTO,
    payload: dados,
  };
}

function setHorariosAtendimento(dados: Object): StoreAction {
  return {
    type: PRE_CADASTRO__SET_HORARIOS_ATENDIMENTO,
    payload: dados,
  };
}

function setAgendamentoAtual(dados: Object | null): StoreAction {
  return {
    type: PRE_CADASTRO__SET_AGENDAMENTO_ATUAL,
    payload: dados,
  };
}

function limparDados(): StoreAction {
  return { type: PRE_CADASTRO__LIMPAR_DADOS };
}

function concluirCadastro(): StoreAction {
  return { type: PRE_CADASTRO__CONCLUIR_CADASTRO };
}

// function jaCadastrado(): StoreAction {
//   return { type: PRE_CADASTRO__JA_CADASTRADO };
// }

function buscarCidades(uf: string) {
  return function (dispatch: DispatchType) {
    // dispatch(startLoading());

    return preCadastroService.buscarCidades(uf)
      .then((resp) => {
        const { data } = resp;
        
        dispatch(setListaCidades(typeof data === typeof [] ? data : []));
      })
      .catch((error) => {
        parseError(error, 'Erro ao tentar conectar');
      });
  }
}

function buscarDatasAtendimento() {
  return function (dispatch: DispatchType) {

    return preCadastroService.buscarDatasAtendimento()
      .then((resp) => {
        const { data } = resp;

        dispatch(setDatasAtendimento(typeof data === typeof [] ? data : []));
      })
      .catch((error) => {
        parseError(error, 'Erro ao tentar conectar');
      });
  }
}

function buscarHorariosAtendimento(data: string) {
  return function (dispatch: DispatchType) {

    return preCadastroService.buscarHorariosAtendimento(data)
      .then((resp) => {
        const { data } = resp;

        dispatch(setHorariosAtendimento(typeof data === typeof [] ? data : []));
      })
      .catch((error) => {
        parseError(error, 'Erro ao tentar conectar');
      });
  }
}

function buscarAgendamentoAtual(cpf: string, dtNascimento: string) {
  return function (dispatch: DispatchType) {
    return preCadastroService.verificaCadastro(cpf)
      .then(respcadastro => {
        if (respcadastro.data !== 0) {
          preCadastroService.buscarAgendamentoAtual(cpf, dtNascimento)
            .then((resp) => {
              const { data } = resp;
              dispatch(setAgendamentoAtual(data));
  
              if (data) {
                if (data.ufID || data.UFID || data.UfID) {
                  preCadastroService.buscarCidades(data.ufID || data.UFID || data.UfID)
                    .then((resp) => {
                      const { data: dataCidade } = resp;
                      
                      dispatch(setListaCidades(typeof dataCidade === typeof [] ? dataCidade : []));
                    })
                    .catch((error) => {
                      parseError(error, 'Erro ao tentar conectar');
                    });
                }
              }
            })
            .catch((error) => {
              parseError(error, 'Erro ao tentar conectar');
            });
        } else { 
          dispatch(setAgendamentoAtual(null));
        }
      }).catch((error) => {
        parseError(error, 'Erro ao tentar conectar');
      });
  }
}

function inicializaEstado() {
  return async function (dispatch: DispatchType) {
    dispatch(setEstadoInicial());

    preCadastroService.buscarDadosIniciais().then((resp) => {
      const { data } = resp;
      dispatch(setDadosIniciais(data));
    });

    preCadastroService.buscarDatasAtendimento().then((resp) => {
      const { data } = resp;
      dispatch(setDatasAtendimento(data));
    });
  }
}

function preCadastrar(form: PreCadastroType) {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    const { preCadastroState: { agendamentoAtual } } = getState();
    if (!agendamentoAtual) {
      preCadastroService.realizarPreCadastro(form).then((resp) => {
        dispatch(limparDados());
        alert(`Pré cadastro realizado com sucesso! Seu código de Cadastro é: ${resp.data.ID}`);
        dispatch(concluirCadastro());
      }).catch((e) => {
        message.error(e.response.data);
      });
    } else {
      preCadastroService.reagendarPreCadastro(form).then(() => {
        dispatch(limparDados());
        alert("Reagendamento realizado com sucesso!");
        dispatch(concluirCadastro());
      }).catch((e) => {
        message.error(e.response.data);
      });
    }
  }
}


const preCadastroActions = {
  inicializaEstado,
  setDados,
  limparDados,
  buscarCidades,
  buscarDatasAtendimento,
  buscarHorariosAtendimento,
  buscarAgendamentoAtual,
  preCadastrar,
  setEstadoInicial,
}

export default preCadastroActions;
